<template>
    <SeatingPlan
        :numberOfSeats="51"
        :doublePlaceholderBefore="[23]"
        :reorderSeats="[47, 48, 51, 49, 50]"
    />
</template>

<script lang="ts" setup>
import SeatingPlan from './SeatingPlan.vue';
</script>
